<template>
  <div class="carousel_controlls">
    <div class="buttons">
      <div class="btn-left" @click="prev"></div>
      <div class="btn-right" @click="next"></div>
    </div>
    <div class="side left" @mouseenter="leftEnter" @mouseleave="leftLeave"></div>
    <div class="side right" @mouseenter="rightEnter" @mouseleave="rightLeave"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    next: Function,
    prev: Function,
  },
  methods: {
    leftEnter(){
      this.$emit('leftEnter');
    },
    leftLeave(){
      this.$emit('leftLeave');
    },
    rightEnter(){
      this.$emit('rightEnter');
    },
    rightLeave(){
      this.$emit('rightLeave');
    },
  }
});
</script>

<style scoped>
.carousel_controlls{
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  pointer-events: none;
}
.buttons{
  pointer-events: all;
  display: flex;
  justify-content: space-between;
  position: absolute;
  width: 11vh;
  bottom: 7vh;
}
@media (orientation: portrait) {
  .buttons{
    bottom: 10vh;
  }
}
.side{
  position: absolute;
  height: 100%;
  width: 15%;
  top: 0;
  pointer-events: all;
}
.left{
  left: 0;
  cursor: w-resize;
}
.right{
  right: 0;
  cursor: e-resize;
}
.btn-left, .btn-right{
  width: 2.5vh;
  height: 2.5vh;
  border-top: 3px solid #fff;
  border-right: 3px solid #fff;
  transform: rotate(45deg);
  cursor: pointer;
}
.btn-left{
  transform: rotate(-135deg);
}
</style>
